import {
  createStyles,
  IconButton,
  makeStyles,
  TextField,
  Theme,
  useTheme,
} from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';
import React from 'react';
import { useNestedHover } from '../../../logic/otherUtilities/useNestedHover';

export interface SimpleSearchProps {
  searchText: string;
  setSearchText: (value: string) => void;
  placeholder: string;
  autoFocus?: boolean;
  disabled?: boolean;
}

const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    hide: {
      opacity: 0,
    },
    searchIcon: {
      margin: theme.spacing(0.5),
      marginRight: theme.spacing(1),
    },
  })
);

const SimpleSearch: React.FC<SimpleSearchProps> = ({
  searchText,
  setSearchText,
  placeholder,
  autoFocus,
  disabled,
}) => {
  //Styling
  const theme = useTheme();
  const classes = useClasses(theme);
  const searchHover = useNestedHover();
  return (
    <TextField
      disabled={disabled}
      value={searchText}
      onChange={(event) => setSearchText(event.target.value)}
      fullWidth
      variant={'outlined'}
      size={'small'}
      autoFocus={autoFocus}
      autoComplete="false"
      autoCorrect="false"
      spellCheck="false"
      placeholder={placeholder}
      onMouseEnter={searchHover.onMouseEnter}
      onMouseLeave={searchHover.onMouseLeave}
      InputProps={{
        autoFocus: true,
        autoComplete: 'false',
        autoCorrect: 'false',
        spellCheck: 'false',
        startAdornment: <Search color={'inherit'} className={classes.searchIcon} />,
        endAdornment: (
          <IconButton size={'small'} onClick={() => setSearchText('')}>
            <Close className={searchHover.isHovered ? null : classes.hide} />
          </IconButton>
        ),
      }}
    />
  );
};

export default SimpleSearch;
